var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.1747 5.29019L5.4147 1.05019C5.50766 0.956464 5.61826 0.88207 5.74012 0.831301C5.86198 0.780533 5.99268 0.754395 6.1247 0.754395C6.25671 0.754395 6.38741 0.780533 6.50927 0.831301C6.63113 0.88207 6.74173 0.956464 6.8347 1.05019C7.02095 1.23756 7.12549 1.49101 7.12549 1.75519C7.12549 2.01938 7.02095 2.27283 6.8347 2.46019L3.2947 6.00019L6.8347 9.54019C7.02095 9.72756 7.12549 9.98101 7.12549 10.2452C7.12549 10.5094 7.02095 10.7628 6.8347 10.9502C6.74126 11.0429 6.63044 11.1162 6.5086 11.166C6.38676 11.2157 6.2563 11.241 6.1247 11.2402C5.99309 11.241 5.86263 11.2157 5.74079 11.166C5.61895 11.1162 5.50814 11.0429 5.4147 10.9502L1.1747 6.71019C1.08097 6.61723 1.00657 6.50663 0.955805 6.38477C0.905036 6.26291 0.878898 6.1322 0.878898 6.00019C0.878898 5.86818 0.905036 5.73747 0.955805 5.61562C1.00657 5.49376 1.08097 5.38316 1.1747 5.29019Z",
    fill: "#781D7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.15f2193b3ed11774aa6db7c3d3688b58.svg";
export { ForwardRef as ReactComponent };